module.exports = __webpack_public_path__ + "img/logo_background.71aebd31.png";